import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChatbotWrapperComponent } from './components/chatbot-wrapper/chatbot-wrapper.component';
import { SharedChatViewerComponent } from './components/shared-chat-viewer/shared-chat-viewer.component';
import { AgentShareChatViewerComponent } from './agents/components/agent-share-chat-viewer/agent-share-chat-viewer.component';

const routes: Routes = [      
  { 
    path: '',
    component: ChatbotWrapperComponent,
  },
  {
    path: 'shared-chat/:token',
    component: SharedChatViewerComponent,
  },
  {
    path: 'agent-shared-chat/:token',
    component: AgentShareChatViewerComponent,
  },
  { path: '**', redirectTo: '' }
 ];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }